module.exports = __webpack_public_path__ + "img/magazin_delo_about_us_1_mob_2x.fcaea5ab.jpg";